module.exports = __webpack_public_path__ + "img/founder3.6c1825e5.jpg";